import React, { useState } from "react"
import { Box, Stack, IconButton, Typography, Button } from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"

type Highlight = {
    title?: string
    archivedUrl: string
}

const getPreviewImage = (url: string) =>
    `https://api.microlink.io/?url=${encodeURIComponent(url)}&screenshot=true&meta=false&embed=screenshot.url`

export const WaybackPreviewCarousel = ({ items }: { items: Highlight[] }) => {
    const [active, setActive] = useState(0)

    if (!items?.length) return null

    const activeItem = items[active]

    const prev = () => setActive((p) => (p === 0 ? items.length - 1 : p - 1))
    const next = () => setActive((p) => (p === items.length - 1 ? 0 : p + 1))

    return (
        <Stack spacing={2} sx={{ width: "100%" }}>
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: 300,
                    borderRadius: 2,
                    overflow: "hidden",
                    border: "1px solid rgba(0,0,0,0.12)",
                }}
            >
                <Box
                    component="img"
                    src={getPreviewImage(activeItem.archivedUrl)}
                    alt={activeItem.title || activeItem.archivedUrl}
                    sx={{
                        width: "100%",
                        height: 300,
                        objectFit: "cover",
                        borderRadius: 2,
                        border: "1px solid rgba(0,0,0,0.12)",
                    }}
                />

                <Button
                    size="small"
                    variant="contained"
                    endIcon={<OpenInNewIcon />}
                    onClick={() =>
                        window.open(activeItem.archivedUrl, "_blank", "noopener,noreferrer")
                    }
                    sx={{
                        position: "absolute",
                        top: 12,
                        right: 12,
                        textTransform: "none",
                        backdropFilter: "blur(6px)",
                    }}
                >
                    Open
                </Button>
            </Box>
            <Stack direction="row" justifyContent="space-between">
                <IconButton onClick={prev}>
                    <ChevronLeftIcon />
                </IconButton>
                <IconButton onClick={next}>
                    <ChevronRightIcon />
                </IconButton>
            </Stack>

            <Stack direction="row" spacing={1} sx={{ overflowX: "auto" }}>
                {items.map((item, idx) => (
                    <Box
                        key={idx}
                        component="img"
                        src={getPreviewImage(item.archivedUrl)}
                        onClick={() => setActive(idx)}
                        sx={{
                            width: 100,
                            height: 70,
                            objectFit: "cover",
                            cursor: "pointer",
                            borderRadius: 1,
                            border: idx === active ? "2px solid #214A98" : "1px solid #ddd",
                        }}
                    />
                ))}
            </Stack>
        </Stack>
    )
}
